// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionWithDivider_section__rsMqr"};